import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgInfo1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M30 3a27 27 0 1 0 27 27A27.03 27.03 0 0 0 30 3m0 48.988A21.988 21.988 0 1 1 51.988 30 22.014 22.014 0 0 1 30 51.988",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M27.498 25.706h5.012v16.418h-5.012zm0-8.577h5.012v4.861h-5.012z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo1);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
